<template lang="pug">
Popup(:visible="visible")
  .exchange-popup-container
    .exchange-title 兑换 {{ exchangeInfo.title }}
    .exchange-price
      img.coin-icon(
        src="https://m.hellobike.com/resource/gallery/833/8TcECPUAyI.png"
        alt=""
      )
      span.price-num {{ exchangeInfo.amount }}
    .pay-btns(v-if="isShowGroupPayment")
      .dialog-btn-earn(@click="handleEarnPoints") 还差{{ exchangeInfo.amount - points }}币，快去赚币
      .dialog-btn-pay(@click="handleConfirmPay")
        |使用
        span {{ exchangeInfo.pointsDeduction }}币+{{ exchangeInfo.salePriceAfterDeduction }}元
        |立得
    .exchange-btns(v-else)
      .exchange-cancel-btn.btn(@click="handleCancel") 再想想
      .exchange-confirm-btn.btn(@click="handleConfirm") 确认兑换
  .dialog-close(@click="handleCancel" v-if="isShowGroupPayment")
    img(src="https://m.hellobike.com/b59275e2_close_popup.png" alt="关闭")
</template>

<script>
import { env, Native } from '@hb/NBridge/lib/h5';
import { configWechatSDK } from '@/utils/wechat';
import Loading from '@/components/loading';
import { purchaseAwardV2, declineCouponOrder } from '@/api/bounty';
import { ParamsUtil } from '@/utils/params';
import { debounce } from '@/utils/index';
import Toast from '@/components/toast';
import Popup from '@/components/popup';
import pay from '@/pages/welfare/common/pay';
import SPM from '../../common/spm';
import { welfareGoCoupon } from '../../utils';
import { loadPlatformAds, showPlatformAds } from '../../common/bridge';
import { processAdParams, loadRewardResultPlatformAds, createCouponOrder } from '../../common/helper';

export default {
  name: 'ExchangePopup',
  components: { Popup },
  props: {
    // 是否显示
    visible: {
      type: Boolean,
      default: false,
    },
    // 兑换信息
    exchangeInfo: {
      type: Object,
      default: () => ({}),
    },
    // 奖励金额
    points: {
      type: Number,
      required: true,
    },
    // 是否是纯净版页面
    pureVersion: {
      type: Boolean,
      default: false,
    },
    // 是否展示为奖励金+钱组合支付的按钮
    isShowGroupPayment: {
      type: Boolean,
      default: false,
    },
    // 触发弹窗来源
    popupSource: {
      type: Number,
      required: true,
    },
    // 是否使用 V2 兑换接口（新人引导专用）
    useV2Api: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  inject: ['isSupportAd'],
  watch: {
    // 弹窗展示监听
    visible(val) {
      if (val) {
        if (this.isShowGroupPayment) {
          const { skuId, title } = this.exchangeInfo;
          SPM.moduleExpose({
            moduleId: 'platform_addCashPopup',
            contentId: 'platform_addCashPopup',
            businessInfo: {
              skuId,
              goodsName: title,
              popupSource: this.popupSource,
              adsource: ParamsUtil.getParams().adsource || '',
            },
          });
        } else {
          SPM.moduleExpose({
            moduleId: 'platform_shangpinduihuanqueren',
            contentId: 'platform_shangpinduihuanqueren',
            businessInfo: {
              popupSource: this.popupSource,
            },
          });
        }
      }
    },
  },
  mounted() {
  },
  methods: {
    // 去赚币
    handleEarnPoints() {
      const isInDetailPage = this.$route.path.includes('/bounty/exchange');
      if (isInDetailPage) {
        // 明细页 goBack
        localStorage.setItem('welfare_need_anchor', '1');
        if (env.isWechatMini) {
          configWechatSDK().then(() => {
            window.wx.miniProgram.navigateBack();
          });
        } else {
          Native.goBack();
        }
      } else {
        // 福利中心页内：直接 emit 走原有锚定逻辑
        this.$emit('earnPoints');
      }

      this.$emit('close');
      const { title, skuId } = this.exchangeInfo;
      SPM.clickButton({
        buttonName: 'platform_popupGoEarning',
        businessInfo: {
          goodsName: title,
          skuId,
          adsource: ParamsUtil.getParams().adsource || '',
        },
      });
    },
    // 积分+现金确认支付
    async handleConfirmPay() {
      const {
        salePriceAfterDeduction, skuId, itemId, salePrice,
        promotionInfos, title, pointsDeduction,
      } = this.exchangeInfo;
      SPM.clickButton({
        buttonName: 'platform_popupAddCash',
        businessInfo: {
          goodsName: title,
          skuId,
          adsource: ParamsUtil.getParams().adsource || '',
          exchangebonus: pointsDeduction,
          exchangeNeedCash: salePriceAfterDeduction,
        },
      });
      let orderId = '';
      try {
        const {
          businessScene,
          businessType,
          orderId: _orderId,
          payMoney,
          payOrderId,
          bannerTaskRelationCouponInfo = {},
          bannerAdvertisementUnitId = '',
        } = await createCouponOrder({
          payAmount: salePriceAfterDeduction,
          itemList: [{
            skuId,
            spuId: itemId,
            num: 1,
            salePrice,
            promotionInfos: (promotionInfos || []).map((v) => ({
              ...v,
              worth: v.deductionAmount,
            })),
          }],
        });
        orderId = _orderId;
        this.handleCancel();
        const res = await pay({
          payOrderInfo: {
            businessScene,
            businessType,
            payMoney,
            payOrderId,
            orderId,
          },
        });
        if (res) {
          this.$emit('bounty');
          this.$emit('success');
          Toast.show('兑换成功');
        }
        // 展示兑换成功弹窗
        this.handleLoadAwardPopup({
          bannerTaskRelationCouponInfo,
          bannerAdvertisementUnitId,
        });
      } catch (error) {
        if (error.code === '2002') {
          Toast.show('用户取消支付');
          const { token: cancelToken, userNewId } = await Native.getTokenAndKey();
          await declineCouponOrder({ orderId, userNewId, token: cancelToken });
        } else {
          Toast.show(error.message || '支付失败');
        }
        this.$emit('bounty');
      }
    },
    // 取消兑换
    handleCancel() {
      this.$emit('close');
    },
    // 确认兑换
    handleConfirm: debounce(async function exec() {
      const {
        saleNum,
        cost,
        skuId,
        price,
        virtualType,
        itemId,
        salePrice,
        promotionInfos,
      } = this.exchangeInfo || {};
      // 确认兑换点击埋点上报
      SPM.clickButton({
        buttonName: 'platform_shangpinduihuanqueren',
        businessInfo: {
          popupSource: this.popupSource,
        },
      });

      // 商品库存不足
      if (!saleNum || saleNum <= 0) {
        return Toast.show('该商品库存不足，请兑换其他商品');
      }
      // 奖励金不足
      if (this.points < cost || this.points === 0) {
        return Toast.show('当前奖励金不足');
      }

      Loading.show();
      // 获取位置信息
      let cityCode;
      let adCode;
      try {
        const cityInfo = await Native.getCityInfo();
        cityCode = cityInfo.cityCode;
        adCode = cityInfo.adCode;
      } catch (e) {
        cityCode = '';
        adCode = '';
      }

      try {
        const { token, ticket } = await Native.getTokenAndKey();

        let orderPort = '1';
        if (env.isEasyBikeApp) {
          orderPort = '1';
        }
        if (env.isAliMP || env.isAliMPMonitor) {
          orderPort = '2';
        }

        // 新版兑换参数
        const v2Params = {
          payAmount: 0,
          itemList: [{
            skuId,
            spuId: itemId,
            num: 1,
            salePrice,
            promotionInfos: (promotionInfos || []).map((v) => ({
              ...v,
              worth: v.deductionAmount,
            })),
          }],
        };

        const v1params = {
          token,
          ticket,
          cityCode,
          adCode,
          skuId,
          purchaseNum: 1,
          virtualSalePrice: cost,
          payAmount: price,
          orderPort,
          virtualType,
          newWelfare: true,
        };

        const result = this.useV2Api
          ? await createCouponOrder(v2Params)
          : await purchaseAwardV2(v1params);

        const isSuccess = this.useV2Api ? !!result : (result && result.code === 0);

        if (isSuccess) {
          this.$emit('bounty');
          this.$emit('success');
          Toast.show('兑换成功');
          // 展示兑换成功弹窗
          const { bannerTaskRelationCouponInfo = {}, bannerAdvertisementUnitId = '' } = (this.useV2Api ? result : result.data) || {};
          if (this.isSupportAd()) {
            this.handleLoadAwardPopup({ bannerTaskRelationCouponInfo, bannerAdvertisementUnitId });
            this.$emit('refreshModule');
          } else {
            this.$emit('showExchangeSuccessPopup', this.exchangeInfo);
          }
        } else {
          Toast.show(result && result.msg);
        }
      } catch (error) {
        Toast.showError(error);
      }

      Loading.close();
      return this.$emit('confirm');
    }, 300),
    // 处理兑换成功弹窗加载
    async handleLoadAwardPopup({ bannerTaskRelationCouponInfo, bannerAdvertisementUnitId }) {
      const { image } = this.exchangeInfo || {};
      const adsInfo = processAdParams({ bannerAdvertisementUnitId, bannerTaskRelationCouponInfo });

      // 加载弹窗
      const loadRes = await loadPlatformAds({
        pageName: 'exchange',
        timeout: '2',
        scene: 'rebateBonus',
        adsource: ParamsUtil.getParams().adsource || '',
        adsInfo: !this.pureVersion ? adsInfo : {},
        otherInfo: {
          data: {
            contentImgUrl: image,
          },
        },
      });

      if (loadRes && loadRes.pageId) {
        // 兑换成功弹窗曝光埋点
        SPM.moduleExpose({
          moduleId: 'Welfare_skuduihuanpop',
          contentId: 'Welfare_skuduihuanpop',
          businessInfo: {
            adv: adsInfo.adUnitId && adsInfo.rewardCount ? '0' : '1',
          },
        });

        // 展示弹窗
        const showRes = await showPlatformAds({
          pageId: loadRes.pageId,
        });
        const { action, inspireType, adsInfo: { rewardTotalCount } = {} } = showRes || {};
        switch (action) {
          // 查看兑换物品
          case 'exchangeLook':
            welfareGoCoupon();
            SPM.clickButton({
              buttonName: 'Welfare_skuduihuanpop_chakan',
              businessInfo: {},
            });
            break;
          // 翻倍广告
          case 'exchangeReward':
            loadRewardResultPlatformAds({
              inspireType,
              bannerTaskRelationCouponInfo,
              otherInfo: {
                data: { rewardCount: rewardTotalCount || '' },
              },
            });
            SPM.clickButton({
              buttonName: 'Welfare_skuduihuanpop_adv',
              businessInfo: {},
            });
            break;
          // 关闭弹窗
          case 'close':
            SPM.clickButton({
              buttonName: 'Welfare_skuduihuanpop_close',
              businessInfo: {},
            });
            break;
          default:
            break;
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.exchange-popup-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.3rem 0.16rem 0.3rem;
  width: 2.75rem;
  background-image:
    linear-gradient(
      180deg,
      #fff8d7 0%,
      #fff 47.57%,
      #fff 47.57%
    );
  border-radius: 0.2rem;

  .exchange-title {
    font-weight: 600;
    font-size: 0.2rem;
    line-height: 0.28rem;
    text-align: center;
  }

  .exchange-price {
    display: flex;
    align-items: center;
    margin-top: 0.08rem;

    .coin-icon {
      margin-right: 0.02rem;
      width: 0.16rem;
      height: 0.16rem;
      vertical-align: bottom;
    }

    .price-num {
      margin-top: 0.01rem;
      color: #ff5729;
      line-height: 0.22rem;
      font-size: 0.16rem;
    }
  }

  .exchange-btns {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 0.24rem;

    .btn {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 0.4rem;
      border-radius: 0.2rem;
      box-sizing: border-box;
      line-height: 0.4rem;
    }

    .exchange-cancel-btn {
      margin-right: 0.08rem;
      width: 0.92rem;
      border: 0.01rem solid #ff5526;
      color: #ff5526;
    }

    .exchange-confirm-btn {
      width: 1.43rem;
      background-color: #ff5526;
      color: #fff;
      font-weight: 500;
    }
  }

  .pay-btns {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .dialog-btn-earn {
      margin-top: 0.24rem;
      height: 0.4rem;
      line-height: 0.4rem;
      background: #ff5526;
      border-radius: 0.2rem;
      font-size: 0.14rem;
      font-weight: 500;
      color: #fff;
      width: 2.15rem;
      text-align: center;
    }

    .dialog-btn-pay {
      margin-top: 0.12rem;
      height: 0.4rem;
      line-height: 0.4rem;
      background: linear-gradient(291.9deg, #ffda9c 29.79%, #ffefd3 89.13%);
      border: 1px solid #ffe4b6;
      border-radius: 0.2rem;
      font-size: 0.14rem;
      font-weight: 500;
      color: #7f3a27;
      width: 2.15rem;
      text-align: center;

      span {
        color: #ff5526;
      }
    }
  }
}

.dialog-close {
  margin: 0.3rem auto 0;
  width: 0.32rem;
  height: 0.32rem;

  img {
    width: 100%;
    height: 100%;
  }
}
</style>
